export default {
    maptiler: {
        url: 'https://api.maptiler.com/maps/hybrid/256/{z}/{x}/{y}.jpg?key=BCle8jzO6zeSfcp3aJR3',
        attribution: '\u003ca href=\"https://www.maptiler.com/copyright/\" target=\"_blank\"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href=\"https://www.openstreetmap.org/copyright\" target=\"_blank\"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
    }
}